'use client';

import { SelectLanguageDynamic as SelectLanguage } from '@/shared/ui/selects/select-language';

export const FooterLanguage = () => <SelectLanguage $menuPlacement="top" />;
